import { createStyles, Theme } from '@material-ui/core'

const TrucksMapStyles = (theme) => createStyles({
  dialogWrapper: {
    zIndex: 1000000,
  },
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    marginTop: '64px',
  },
  map: {
    height: '100%',
  },
  chip: {
    backgroundColor: 'red',
  },
  circularProgress: {
    color: theme.palette.grey[`500`],
  },
  appBar: {
    backgroundColor: '#fff',
    color: '#000',
  },
})

export default TrucksMapStyles
